<bai-brightai-layout>
  <lib-conversation-list column1 [collapsed]="collapsed()"></lib-conversation-list>
  <lib-chat column2 class="flex-1 min-h-0" [disableChat]="true"></lib-chat>
</bai-brightai-layout>
